import hospitalReducer from "./hospitalReducer";

const institutionReducers = {
    hospital: hospitalReducer
}

export default institutionReducers;